import { PackageType } from '@frontend/package/types';
import { ScreenType } from '@frontend/wizard/types';

import { useColliConfirmOpenSlotsParallel } from '../../hooks/use-colli-confirm-open-slots-parallel';

const useDropOffConfirmOpenSlotsParallel = () =>
    useColliConfirmOpenSlotsParallel({
        screenType: ScreenType.DROP_OFF_CONFIRM_OPEN_SLOTS_PARALLEL,
        packageType: PackageType.DROP_OFF
    });

export default useDropOffConfirmOpenSlotsParallel;
